




































































import { Component, Vue, Prop } from "vue-property-decorator";
import { Action, Getter } from "vuex-class";
import { ElInput } from "element-ui/types/input";
import { ElSelect } from "element-ui/types/select";
import { ElForm } from "element-ui/types/form";
import { MESSAGE } from "@/models/Message";
import { Utils } from "@/services/utils";

import InputString from "@/views/components/input/InputString.vue";

@Component({
  components: {
    InputString
  }
})
export default class LoginBox extends Vue {
  @Action("setToken", { namespace: "AuthStore" }) public setToken: any;
  @Getter("getToken", { namespace: "AuthStore" }) public token: any;

  @Prop({ default: "company" }) public authMode!: string;
  @Prop() public staffData: any;
  @Prop({ default: false }) public hasBorder!: boolean;
  @Prop({ default: "" }) public errorMsg!: string;

  // デプロイ確認用バージョン値:カウントアップで進める
  private versionLabel: number = 10002;

  public rules: any = {
    username: [{ validator: this.validateUser, trigger: "blur" }],
    password: [{ validator: this.validatePass, trigger: "blur" }]
  };

  public utils: any = new Utils();

  public $refs!: {
    loginForm: ElForm;
    userInput: ElInput;
    userSelect: ElSelect;
    pwdInput: ElInput;
  };

  public form = {
    username: "",
    password: ""
  };

  public loading: boolean = false;
  public passwordType = "password";
  public loginService: any;
  public staffSelected: any;

  constructor() {
    super();
  }

  created() {
    // デプロイ確認用バージョン値出力
    console.log("FV:" + this.versionLabel);
  }

  public validateUser(rule: any, value: string, callback: any) {
    if (value === "") {
      callback(new Error(MESSAGE.InvalidUser));
    } else {
      callback();
    }
  }

  public validatePass(rule: any, value: string, callback: any) {
    if (value === "") {
      callback(new Error(MESSAGE.InvalidPassWord));
    } else {
      callback();
    }
  }

  public showPwd() {
    this.passwordType = this.passwordType === "password" ? "text" : "password";
  }

  public onSubmit() {
    this.$refs.loginForm.validate((valid: boolean) => {
      if (valid) {
        this.$emit("onSubmit", this.form);
      }
    });
  }

  public selectStaff() {
    const data = this.staffData.filter(
      (e: any) => e.staffCd === this.form.username
    );
    this.$emit("onStaffSelected", data[0]);
  }

  removeAttr(focus: boolean) {
    setTimeout(() => {
      const input = document.getElementById("input-pwd");
      if (input && input.hasAttribute("readonly")) {
        input.removeAttribute("readonly");
        if(focus) {
          this.$refs.pwdInput.focus();
        }
      }
    });
  }
  onEnter() {
    this.removeAttr(true);
  }

  onPwdFocus() {
    this.removeAttr(false);
  }
}
